import { Component, OnInit, TemplateRef } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ListService } from "../../../../auth/service/list.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

interface IFinancialRelevance {
  id: number | null;
  name: string | null;
  other: { code: string | null; has_cig_and_cup: boolean };
}

@Component({
  selector: "app-track-financial-relevance",
  templateUrl: "./track-financial-relevance.component.html",
})
export class TrackFinancialRelevanceComponent implements OnInit {
  public contentHeader: IContentHeader;
  private list_type: string = "customer_financial_relevance";
  private customerTypeList = [];
  public filteredTypesList = [];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public showModalError: boolean = false;
  public typeForm: IFinancialRelevance = {
    id: null,
    name: null,
    other: {
      code: null,
      has_cig_and_cup: false,
    },
  };

  constructor(
    public listService: ListService,
    private _routerService: Router,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _modalService: NgbModal,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.CUSTOMERS_TRACK_FINANCE_RELEVANCE_PLURAL",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.CUSTOMERS",
            isLink: false,
          },
          {
            name: "MENU.CUSTOMERS_TRACK_FINANCE_RELEVANCE_PLURAL",
            isLink: false,
          },
        ],
      },
    };
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.listService.getList(this.list_type).then((result: IFinancialRelevance[]) => {
      this.customerTypeList = result;
      this.filterTypes();
    });
  }

  filterTypes() {
    const key: string = this.searchKeyword.trim().toLowerCase();
    let filterItem: IFinancialRelevance[] = this.customerTypeList;
    if (key.length > 0) {
      filterItem = filterItem.filter((item: IFinancialRelevance) => item.name.toLowerCase().trim().includes(key));
    }
    this.filteredTypesList = filterItem;
  }

  modalOpen(modal: TemplateRef<any>, selectedType: IFinancialRelevance | undefined = undefined) {
    this._modalService.open(modal, {
      size: "md",
      centered: true,
    });
    this.typeForm = {
      id: null,
      name: "",
      other: {
        code: "",
        has_cig_and_cup: false,
      },
    };
    if (selectedType) {
      this.typeForm = selectedType;
    }
    this.showModalError = false;
  }

  isError(): boolean {
    this.showModalError = this.typeForm.name === null || this.typeForm.name.length < 1 || this.typeForm.other.code === null || this.typeForm.other.code.length < 1;
    return this.showModalError;
  }

  async addType() {
    if (!this._authenticationService.hasCapability("create_customer_financial_relevance")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .create(this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_ADD_TRACK_FINANCE_RELEVANCE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
            has_cig_and_cup: false,
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_ADD_TRACK_FINANCE_RELEVANCE");
      });
  }

  async editType() {
    if (!this._authenticationService.hasCapability("edit_customer_financial_relevance")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const idType: number = this.typeForm.id;
    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .update(idType, this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_EDIT_TRACK_FINANCE_RELEVANCE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
            has_cig_and_cup: false,
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_EDIT_TRACK_FINANCE_RELEVANCE");
      });
  }

  async deleteType(selectedType: any) {
    if (!this._authenticationService.hasCapability("delete_customer_financial_relevance")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedType.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.listService.delete(selectedType.id, this.list_type).then(() =>
            this._utilService.showPopupItemDeleted().then(async () => {
              this.load();
              await this._utilService.showToastrSuccess("SUCCESS_DELETE_TRACK_FINANCE_RELEVANCE");
            }),
          );
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showToastrError("ERROR_DELETE_TRACK_FINANCE_RELEVANCE"));
  }
}
